// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Login.css */

  #root {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  .login-container {
    background: #1a1a2e;
    width: 100%;
    max-width: 400px;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .login-container h1 {
    color: #ffffff;
    margin-bottom: 1.5rem;
  }
  
  .login-form {
    display: flex;
    flex-direction: column;
  }
  
  .login-form input {
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: none;
    border-radius: 4px;
  }
  
  .login-form button {
    padding: 0.75rem;
    border: none;
    border-radius: 4px;
    background-color: #0CF2A8;
    color: black;
    cursor: pointer;
  }

  .jumpcloudSSO {
    padding: 0.75rem;
    border: none;
    border-radius: 4px;
    background-color: #0CF2A8;
    color: black;
    cursor: pointer;
  }

  
  .login-form button:hover {
    background-color: #45a049;
  }
  
  .login-form .signup-link {
    margin-top: 1rem;
    color: #ffffff;
  }
  
  .login-form .signup-link a {
    color: #4caf50;
    text-decoration: none;
  }
  
  .error-message {
    color: #ff0000;
    margin-bottom: 1rem;
  }
  
  .logo {
    margin-bottom: 2rem;
    max-height:60px;
  }
  
  @media (max-width: 768px) {
    .logo {
      display: block;
      /* margin: 0 auto 2rem; */
    }
  }
  
  @media (min-width: 769px) {
    .logo {
      display: block;
      /* margin: 0 0 2rem auto; */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,6BAA6B;;EAE3B;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,eAAe;EACjB;;;EAGA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE;MACE,cAAc;MACd,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,cAAc;MACd,2BAA2B;IAC7B;EACF","sourcesContent":["/* src/components/Login.css */\n\n  #root {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n  }\n  .login-container {\n    background: #1a1a2e;\n    width: 100%;\n    max-width: 400px;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .login-container h1 {\n    color: #ffffff;\n    margin-bottom: 1.5rem;\n  }\n  \n  .login-form {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .login-form input {\n    padding: 0.75rem;\n    margin-bottom: 1rem;\n    border: none;\n    border-radius: 4px;\n  }\n  \n  .login-form button {\n    padding: 0.75rem;\n    border: none;\n    border-radius: 4px;\n    background-color: #0CF2A8;\n    color: black;\n    cursor: pointer;\n  }\n\n  .jumpcloudSSO {\n    padding: 0.75rem;\n    border: none;\n    border-radius: 4px;\n    background-color: #0CF2A8;\n    color: black;\n    cursor: pointer;\n  }\n\n  \n  .login-form button:hover {\n    background-color: #45a049;\n  }\n  \n  .login-form .signup-link {\n    margin-top: 1rem;\n    color: #ffffff;\n  }\n  \n  .login-form .signup-link a {\n    color: #4caf50;\n    text-decoration: none;\n  }\n  \n  .error-message {\n    color: #ff0000;\n    margin-bottom: 1rem;\n  }\n  \n  .logo {\n    margin-bottom: 2rem;\n    max-height:60px;\n  }\n  \n  @media (max-width: 768px) {\n    .logo {\n      display: block;\n      /* margin: 0 auto 2rem; */\n    }\n  }\n  \n  @media (min-width: 769px) {\n    .logo {\n      display: block;\n      /* margin: 0 0 2rem auto; */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
